module.exports = __webpack_public_path__ + "img/ios-checkbox-outline.dc2e64ee.svg";